export default __webpack_public_path__ + "static/media/maiarpunks-logo.7f37b371.png";